//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid, Box, Tabs, Tab } from '@mui/material';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
/** Icons Import */

import dayjs from 'dayjs';
import { PropTypes } from 'prop-types';
import PPE_BASIC_01F from '../PPE_BASIC_01/PPE_BASIC_01F';
import PPE_BASIC_02F from '../PPE_BASIC_02/PPE_BASIC_02F';
import { AuthButton } from '../../../../Components/MUIs';
import PPE_BASIC_03F from '../PPE_BASIC_03/PPE_BASIC_03F';
import PPE_BASIC_04F from '../PPE_BASIC_04/PPE_BASIC_04F';
import { useDispatch, useSelector } from 'react-redux';
import {
  setEndDate,
  setMonth,
  setSearchText,
  setYear,
} from '../../../../Reducer/SearchReducer';
//#endregion

function A11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index } = props;

  return (
    <React.Fragment>
      {value === index && (
        <Box sx={{ height: '100%', width: '100%' }}>{children}</Box>
      )}
    </React.Fragment>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function PPE_BASIC(props) {
  //#region 변수
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.SearchInfo);

  //#endregion
  //#region 웹

  //#endregion
  //#region 함수

  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="PPEManagement"
          searchYn="Y"
          saveYn={props.value === 0 || props.value === 2 ? 'Y' : 'N'}
          printYn={props.value === 1 || props.value === 2 ? 'Y' : 'N'}
          searchClick={(e) => {
            if (!props.validateSelection()) return;

            dispatch(setSearchText(e));
            if (props.value === 0) {
              props.setFilterClick1(true);
            } else if (props.value === 1) {
              props.setFilterClick2(true);
            } else if (props.value === 2) {
              props.setFilterClick3(true);
            } else if (props.value === 3) {
              props.setFilterClick4(true);
            }
          }}
          saveClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setSaveClick1(true);
            } else if (props.value === 1) {
              props.setSaveClick2(true);
            } else if (props.value === 2) {
              props.setSaveClick3(true);
            } else if (props.value === 3) {
              props.setSaveClick4(true);
            }
          }}
          deleteClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setDeleteClick1(true);
            } else if (props.value === 1) {
              props.setDeleteClick2(true);
            } else if (props.value === 2) {
              props.setDeleteClick3(true);
            } else if (props.value === 3) {
              props.setDeleteClick4(true);
            }
          }}
          printClick={() => {
            if (!props.validateSelection()) return;

            if (props.value === 0) {
              props.setPrintClick1(true);
            } else if (props.value === 1) {
              props.setPrintClick2(true);
            } else if (props.value === 2) {
              props.setPrintClick3(true);
            } else if (props.value === 3) {
              props.setPrintClick4(true);
            }
          }}
          conditions={[
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: searchInfo.coList,
                    value: searchInfo.coCd,
                    onChange: async (e) => {
                      await props.handleCoChange(e);

                      if (props.value === 0) {
                        await props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        await props.setSearchClick2(true);
                      } else if (props.value === 2) {
                        await props.setSearchClick3(true);
                      } else if (props.value === 3) {
                        await props.setSearchClick4(true);
                      }
                    },
                  },
                ]
              : []),
            ...(props.value === 2
              ? [
                  {
                    type: 'datePicker',
                    views: ['year'],
                    openTo: 'year',
                    title: '연도',
                    name: '조회연도',
                    value: searchInfo.year
                      ? dayjs(`${searchInfo.year}`, 'YYYY')
                      : dayjs(),
                    onChange: (date) => {
                      if (date) {
                        const changeYear = dayjs(date).format('YYYY');
                        dispatch(setYear(changeYear));
                        props.setSearchClick3(true);
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY',
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: searchInfo.custList,
              value: searchInfo.custCd,
              onChange: async (e) => {
                await props.handleCustChange(e);

                if (props.value === 0) {
                  await props.setSearchClick1(true);
                } else if (props.value === 1) {
                  await props.setSearchClick2(true);
                } else if (props.value === 2) {
                  await props.setSearchClick3(true);
                } else if (props.value === 3) {
                  await props.setSearchClick4(true);
                }
              },
            },
            ...(props.value === 1
              ? [
                  {
                    type: 'datePicker',
                    views: ['year', 'month'],
                    openTo: 'month',
                    title: '월',
                    name: '조회년월',
                    value:
                      searchInfo.year && searchInfo.month
                        ? dayjs(
                            `${searchInfo.year}-${searchInfo.month}`,
                            'YYYY-MM'
                          )
                        : dayjs(),
                    onChange: (date) => {
                      if (date) {
                        dispatch(setYear(dayjs(date).format('YYYY')));
                        dispatch(setMonth(dayjs(date).format('MM')));
                        props.setSearchClick2(true);
                      }
                    },
                    currentLocale: 'ko',
                    format: 'YYYY-MM',
                  },
                ]
              : []),
            ...(props.value !== 0 && props.value !== 1 && props.value !== 2
              ? [
                  {
                    type: 'combo',
                    name: '부서',
                    items: searchInfo.depList,
                    value: searchInfo.depCd,
                    onChange: async (e) => {
                      await props.handleDepChange(e);

                      if (props.value === 0) {
                        await props.setSearchClick1(true);
                      } else if (props.value === 1) {
                        await props.setSearchClick2(true);
                      } else if (props.value === 2) {
                        await props.setSearchClick3(true);
                      } else if (props.value === 3) {
                        await props.setSearchClick4(true);
                      }
                    },
                  },
                ]
              : []),
            ...(props.value === 3
              ? [
                  {
                    type: 'datePicker',
                    title: '기간',
                    name: '자가 체크 일자',
                    value: searchInfo.endDate
                      ? dayjs(searchInfo.endDate)
                      : dayjs(),
                    onChange: (date) => {
                      if (date) {
                        dispatch(setEndDate(dayjs(date).format('YYYY-MM-DD')));
                        props.setSearchClick4(true);
                      }
                    },
                    currentLocale: 'ko',
                  },
                ]
              : []),
          ]}
          grids={
            <React.Fragment>
              <Box>
                <Tabs
                  value={props.value}
                  onChange={props.HandleChange}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label="보호구 관리대장"
                    {...A11yProps(0)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="보호구 관리대장"
                    {...A11yProps(1)}
                    sx={{
                      display: 'none',
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="보호구 지급대장"
                    {...A11yProps(2)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                  <Tab
                    label="보호구 자가 체크 기록"
                    {...A11yProps(3)}
                    sx={{
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#000',
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={props.value} index={0}>
                <PPE_BASIC_01F
                  value={props.value}
                  filterClick1={props.filterClick1}
                  setFilterClick1={props.setFilterClick1}
                  searchClick1={props.searchClick1}
                  setSearchClick1={props.setSearchClick1}
                  addClick1={props.addClick1}
                  setAddClick1={props.setAddClick1}
                  saveClick1={props.saveClick1}
                  setSaveClick1={props.setSaveClick1}
                  deleteClick1={props.deleteClick1}
                  setDeleteClick1={props.setDeleteClick1}
                  printClick1={props.printClick1}
                  setPrintClick1={props.setPrintClick1}
                  getDepLastName={props.getDepLastName}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={1}>
                <PPE_BASIC_02F
                  value={props.value}
                  filterClick2={props.filterClick2}
                  setFilterClick2={props.setFilterClick2}
                  searchClick2={props.searchClick2}
                  setSearchClick2={props.setSearchClick2}
                  addClick2={props.addClick2}
                  setAddClick2={props.setAddClick2}
                  saveClick2={props.saveClick2}
                  setSaveClick2={props.setSaveClick2}
                  deleteClick2={props.deleteClick2}
                  setDeleteClick2={props.setDeleteClick2}
                  printClick2={props.printClick2}
                  setPrintClick2={props.setPrintClick2}
                  getDepLastName={props.getDepLastName}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={2}>
                <PPE_BASIC_03F
                  value={props.value}
                  filterClick3={props.filterClick3}
                  setFilterClick3={props.setFilterClick3}
                  searchClick3={props.searchClick3}
                  setSearchClick3={props.setSearchClick3}
                  addClick3={props.addClick3}
                  setAddClick3={props.setAddClick3}
                  saveClick3={props.saveClick3}
                  setSaveClick3={props.setSaveClick3}
                  deleteClick3={props.deleteClick3}
                  setDeleteClick3={props.setDeleteClick3}
                  printClick3={props.printClick3}
                  setPrintClick3={props.setPrintClick3}
                  getDepLastName={props.getDepLastName}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
              <CustomTabPanel value={props.value} index={3}>
                <PPE_BASIC_04F
                  value={props.value}
                  filterClick4={props.filterClick4}
                  setFilterClick4={props.setFilterClick4}
                  searchClick4={props.searchClick4}
                  setSearchClick4={props.setSearchClick4}
                  addClick4={props.addClick4}
                  setAddClick4={props.setAddClick4}
                  saveClick4={props.saveClick4}
                  setSaveClick4={props.setSaveClick4}
                  deleteClick4={props.deleteClick4}
                  setDeleteClick4={props.setDeleteClick4}
                  printClick4={props.printClick4}
                  setPrintClick4={props.setPrintClick4}
                  getDepLastName={props.getDepLastName}
                  validateSelection={props.validateSelection}
                />
              </CustomTabPanel>
            </React.Fragment>
          }
        />
      </Grid>
    </Grid>
  );
}

export default PPE_BASIC;
